import { HttpContextToken } from "@angular/common/http";

export const SkipErrorMessageTokenInterceptor = new HttpContextToken(
  () => true,
);
